/*
 * 与客户端交互的函数模块
 */

import {BUS} from "./bus";
import { transformJsbData } from '@cmbi/lib';

const ua = window.navigator.userAgent.toLowerCase();
window.interactiveHandle = data => {
	return interactiveHandle(data);
};
const Queues = new (class {
	constructor() {
		this.Queues = {};
		this.QueuesByOne = {};
	}
	in(name, v) {
		if (name && v) {
			this.Queues[name] = this.Queues[name] ? [...this.Queues[name], v] : [v];
		}
	}
	out(name) {
		let currentQueue = this.Queues[name] || [];
		return currentQueue;
	}
	clear(name) {
		this.Queues[name] = null;
	}
	inOneQueue(name, v) {
		this.QueuesByOne[name] = v;
	}
	getValInOnQueue(name) {
		return this.QueuesByOne[name];
	}
})();
const isIOS = () => {
	return !!ua.match(/ios/i);
};

const isAndroid = () => {
	return ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
};

const isMobile = () => {
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let getArr = Agents.filter(i => userAgentInfo.includes(i));
    return getArr.length ? true : false;
}

const isZyapp = () => {
	return ua.indexOf("zyapp") > -1;
};

const isWeiXin = () => {
    return ua.indexOf('micromessenger') !== -1;
};

const isTokenApp = () => {
	return ua.indexOf("app_name/token") > -1;
};

const jsonEscape = str => {
	return str.replace(/\n/g, "").replace(/\t/g, "");
};

const interactiveHandle = data => {
	try {
		const _data = JSON.parse(jsonEscape(data));
		// let params = _data.params;
		if (_data.type === 'updateSession' || _data.type === 'setUserInfo') {
			transformJsbData(_data.params);
			console.log('transformJsbData=====>', _data.params);
		}
		console.log(`native调h5  =======>${data}`);
		switch (_data.type) {
			case "updateSession":
				_updateSessionFn(_data.params);
			case "setUserInfo":
				if (_data.type == "setUserInfo") {
					_getUserInfo(_data.params);
				}
			case "pageVisible":
			case "appSetting":
				BUS.$emit(_data.type, _data.params);
				break;
			case "metadata":
				_getMetaData(_data.params);
				break;
		}
	} catch (e) {
		console.log(e, "error");
	}
	return this;
};

const commandHandler = notifyObj => {
	try {
		console.log(`h5调native =======>${JSON.stringify(notifyObj)}`);
		if (isIOS()) {
			window.webkit.messageHandlers.ZYHQ.postMessage(JSON.stringify(notifyObj));
		} else {
			window.ZYHQ && window.ZYHQ.commonHandler(JSON.stringify(notifyObj));
		}
	} catch (error) {
		console.log(error);
	}
	return this;
};
let _updateSessionFn = (data) => {
	Queues.out('updateSession').map(r => {
		(typeof (r) =='function')&&r(data);
	});
	Queues.clear('updateSession');
};
const exchangeSession=()=> {
	// 兼容令牌的jsbridge方法调用无回调问题
	if (!isThanAppVersion('1.3.1') || isTokenApp()) return {};
	const promise = new Promise(res => {
		Queues.in('updateSession',res);
	});
	const notifyObj = {
		type: 'exchangeSession'
	};
	commandHandler(notifyObj);
	return promise
};
//获取端的信息
const _getMetaData = data => {
	excQueues(data.key, data.value);
	Queues.out(data.key).map(r => {
		typeof r == "function" && r(data.value);
	});
	Queues.clear(data.key);
};
const getMetaData = key => {
	if (!key) {
		return;
	}
	const promise = new Promise(res => {
		Queues.in(key, res);
	});
	commandHandler({
		type: "getMetadata",
		params: {
			key
		}
	});
	return promise;
};
const getMetaDataByOne = key => {
	// 兼容令牌的jsbridge方法调用无回调问题
	if (!isThanAppVersion('1.3.1') || isTokenApp()) return null;
	let promise = Queues.getValInOnQueue(key);
	if (!promise) {
		promise = new Promise(res => {
			Queues.in(key, res);
		});
		Queues.inOneQueue(key, promise);
		commandHandler({
			type: "getMetadata",
			params: {
				key
			}
		});
	}
	return promise;
};
//关闭窗口
const closePage = () => {
	if (isZyapp()) {
		commandHandler({
			type: "closePage"
		});
	}
};

// 增加关闭icon
const showCloseIcon = () => {
	if (isZyapp()) {
		commandHandler({
			type: "closeICON"
		});
	}
};

//native打开新窗口
const openPage = params => {
	if (isZyapp()) {
		const link = params.url.includes("zyapp://") ? params.url : decodeURIComponent(params.url);
		commandHandler({
			type: "openPage",
			params: {
				link,
				close: "0",
			}
		});
	} else {
		window.location.href = params.url;
	}
};

const getVersion = () => {
	const index = ua.indexOf("zyapp");
	if (index == -1) {
		return "1.0.0";
	} else {
		const reg = /zyapp\/.+?\(/;
		let value = ua.match(reg);
		if (value && value[0]) {
			value = value[0].replace(/\s+/g, "").slice(6, -1);
		}
		return value;
	}
};

// 比较版本号
const isThanAppVersion = version => {
	const currentVersion = getVersion();
	const deviceVersion = currentVersion.split(".");
	const compareVersion = version.split(".");
	if ((compareVersion && compareVersion.length < 3) || (deviceVersion && deviceVersion.length < 3)) {
		return false;
	}
	const deviceValue =
		parseInt(deviceVersion[0], 10) * 10000 + parseInt(deviceVersion[1], 10) * 100 + parseInt(deviceVersion[2], 10);
	const compareValue =
		parseInt(compareVersion[0], 10) * 10000 +
		parseInt(compareVersion[1], 10) * 100 +
		parseInt(compareVersion[2], 10);
	return deviceValue >= compareValue;
};

const showCustomerServiceInfo = () => {
	if (isZyapp()) {
		commandHandler({
			type: "showCustomerServiceInfo"
		});
	}
};

const _getUserInfo = data => {
	return excQueues("getUserInfo", data);
};

const excQueues = (key, data) => {
	Queues.out(key).map(r => {
		typeof r == "function" && r(data);
	});
};

const openStock = code => {
	if (isZyapp()) {
		commandHandler({
			type: "stock",
			params: {
				code
			}
		});
	}
};

export {isIOS, isAndroid, isMobile, isZyapp, isTokenApp, isWeiXin, commandHandler, interactiveHandle, closePage, openPage, isThanAppVersion, showCloseIcon, getMetaData, getMetaDataByOne, exchangeSession, showCustomerServiceInfo, openStock};
